module.exports = __webpack_public_path__ + "static/media/iphone_13_pro_gold.a81cd0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_13_pro_gold.png
// module id = 2119
// module chunks = 0